import React from 'react'
import { UploadElement } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24DocumentPlus24 } from '@is24/cosma-ui-icons'
import styles from './AiEmptyUploadDocumentSection.module.css'

interface AiEmptyUploadDocumentSectionProps {
  onFileSelect: (files: FileList | null) => void
}

export const AiEmptyUploadDocumentSection = ({ onFileSelect }: AiEmptyUploadDocumentSectionProps) => {
  const { t } = useTranslation()

  return (
    <section>
      <h3 className='font-body-medium-bold margin-bottom-s'>
        {t('wizard.uploadAiBanner.modal.documents.sectionTitle')}
      </h3>
      <div className={styles.documentsGrid}>
        <div data-testid='ai-upload-floor-plan-tile'>
          <UploadElement.Root
            className='margin-bottom-s'
            onFileSelect={onFileSelect}
            status='empty'
            accept='image/jpeg,image/gif,image/png,application/pdf'
          >
            <UploadElement.Dropzone>
              <UploadElement.Icon>
                <IconS24DocumentPlus24 />
              </UploadElement.Icon>
              <UploadElement.Content>
                <UploadElement.Title>{t('wizard.uploadAiBanner.modal.documents.floorPlan.title')}</UploadElement.Title>
                <UploadElement.Description>
                  {t('wizard.uploadAiBanner.modal.documents.floorPlan.supportText')}
                </UploadElement.Description>
              </UploadElement.Content>
            </UploadElement.Dropzone>
            <UploadElement.Error>{t('wizard.uploadAiBanner.modal.fileRequiredError')}</UploadElement.Error>
          </UploadElement.Root>
        </div>
        <div data-testid='ai-upload-energy-certificate-tile'>
          <UploadElement.Root onFileSelect={onFileSelect} status='empty' accept='application/pdf'>
            <UploadElement.Dropzone>
              <UploadElement.Icon>
                <IconS24DocumentPlus24 />
              </UploadElement.Icon>
              <UploadElement.Content>
                <UploadElement.Title>
                  {t('wizard.uploadAiBanner.modal.documents.energyCertificate.title')}
                </UploadElement.Title>
                <UploadElement.Description>
                  {t('wizard.uploadAiBanner.modal.documents.energyCertificate.supportText')}
                </UploadElement.Description>
              </UploadElement.Content>
            </UploadElement.Dropzone>
            <UploadElement.Error>{t('wizard.uploadAiBanner.modal.fileRequiredError')}</UploadElement.Error>
          </UploadElement.Root>
        </div>
      </div>
    </section>
  )
}
